// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-k_gz","advertDetailHeaderPrice__value":"c-k_gA","advertDetailHeaderPrice__label":"c-k_gB"};